export default {
  anacef: {
    arr_con: {
      cubierta: {
        left: 18.82,
        bottom: 54.13
      },
      maquinas: {
        left: 34.50,
        bottom: 41.99
      },
      cocina: {
        left: 56.07,
        bottom: 53.60
      },
      puente: {
        left: 74.50,
        bottom: 64.65
      }
    }
  },
  oppao: {
    pal_fon: {
      cubierta: {
        left: 15.96,
        bottom: 41.96
      },
      maquinas: {
        left: 25.08,
        bottom: 28.68
      },
      cocina: {
        left: 42.99,
        bottom: 40.17
      },
      puente: {
        left: 52.44,
        bottom: 52.23
      }
    },
    arr_lit_nea: {
      cubierta: {
        left: 18.03,
        bottom: 46.87
      },
      maquinas: {
        left: 31.47,
        bottom: 41.96
      },
      cocina: {
        left: 48.19,
        bottom: 48.66
      },
      puente: {
        left: 64.59,
        bottom: 57.14
      }
    }
  },
  opplugo: {
    arr_lit_nea: {
      cubierta: {
        left: 18.03,
        bottom: 46.87
      },
      maquinas: {
        left: 31.47,
        bottom: 41.96
      },
      cocina: {
        left: 48.19,
        bottom: 48.66
      },
      puente: {
        left: 64.59,
        bottom: 57.14
      }
    },
    cer_lit: {
      puente: {
        left: 67.45,
        bottom: 64.70
      },
      cubierta: {
        left: 20.39,
        bottom: 49.46
      }
    },
    pal_sup: {
      cubierta: {
        left: 23.33,
        bottom: 39.81
      },
      maquinas: {
        left: 36.88,
        bottom: 35.14
      },
      cocina: {
        left: 64.81,
        bottom: 43.2
      },
      puente: {
        left: 49.85,
        bottom: 48.39
      }
    },
    pal_fon: {
      cubierta: {
        left: 15.96,
        bottom: 41.96
      },
      maquinas: {
        left: 29.08,
        bottom: 32.68
      },
      cocina: {
        left: 42.99,
        bottom: 40.17
      },
      puente: {
        left: 52.44,
        bottom: 52.23
      }
    }
  },
  opromar: {
    cer_lit: {
      puente: {
        left: 67.00,
        bottom: 59.70
      },
      cubierta: {
        left: 20.39,
        bottom: 43.46
      }
    },
    arr_lit_nea: {
      cubierta: {
        left: 18.03,
        bottom: 46.87
      },
      maquinas: {
        left: 31.47,
        bottom: 41.96
      },
      cocina: {
        left: 48.19,
        bottom: 48.66
      },
      puente: {
        left: 64.59,
        bottom: 57.14
      }
    },
    pal_sup: {
      cubierta: {
        left: 23.33,
        bottom: 39.81
      },
      maquinas: {
        left: 36.88,
        bottom: 35.14
      },
      cocina: {
        left: 64.81,
        bottom: 43.2
      },
      puente: {
        left: 49.85,
        bottom: 48.39
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/shipJobsPositions.js